module.exports = __webpack_public_path__ + "img/11.3c2e4d2e.jpg";